import { useState } from 'react'
import Link from 'next/link'
import parse from 'html-react-parser'

import styles from './style.module.css'
import fromNow from '@src/helpers/fromNow'

export default function NotificationItem({
  item: { message, onClick, Icon, read, url, dateCreated },
}) {
  const [hover, setHover] = useState(false)
  let notificationStyle = { cursor: 'pointer' }
  return (
    <div
      className={styles.notificationItem}
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={notificationStyle}
    >
      {Icon && (
        <div className={styles.icon}>
          <Icon hover={hover} className={styles.iconImage} />
        </div>
      )}
      {url ? (
        <Link href={`/${url}`} passHref>
          <a>
            <div className={styles.notificationText}>
              {parse(message)}
              <div className={styles.notificationDate}>
                {fromNow(new Date(dateCreated))}
              </div>
            </div>
          </a>
        </Link>
      ) : (
        <div className={styles.notificationText} style={{ cursor: 'initial' }}>
          {parse(message)}
          <div className={styles.notificationDate}>
            {fromNow(new Date(dateCreated))}
          </div>
        </div>
      )}
      {!read && (
        <div className={styles.unread}>
          <div className={styles.unreadDot} />
        </div>
      )}
    </div>
  )
}
